import { useCallback } from 'react';

import CustomDialog from '../common/custom-dialog';

import useStyles from './DeleteOrderWhimDialog.styles';

function DeleteOrderWhimDialog(props) {
  const {
    confirm,
    title,
    description,
    onBack,
    onClickDelete,
    onClose,
    open,
    whimId,
  } = props;

  const componentClasses = useStyles();

  const onClickDeleteLocal = useCallback(async () => {
    await onClickDelete(whimId);
  }, [onClickDelete, whimId]);

  return (
    <CustomDialog
      classes={{
        headerRoot: componentClasses.headerRoot,
        footerRoot: componentClasses.footerRoot,
        paper: componentClasses.paper,
      }}
      actions={[
        {
          text: confirm,
          onClick: onClickDeleteLocal,
          color: 'primary',
          variant: 'contained',
          fullWidth: false,
        },
      ]}
      onClickBackButton={onBack}
      onClose={onClose}
      open={open}
      showBackButton
      showCloseButton
      title={title}
    >
      <div className={componentClasses.container}>{description}</div>
    </CustomDialog>
  );
}

export default DeleteOrderWhimDialog;
